/**
 * Holds the in-memory access token so the axios interceptor (a module-level
 * singleton) can read/update it without depending on React context.
 * AuthContext is the single writer; everything else only reads via
 * getAccessToken().
 */
let accessToken: string | null = null;

export const getAccessToken = () => accessToken;
export const setAccessToken = (token: string | null) => {
  accessToken = token;
};
